import styled from 'styled-components';
import { extractNumber } from '../../../functions/utils/extractNumber';
import { LauncherElementData, useLauncherElementsStore } from '../../../hooks/stores/launcherElementsStore';

export const MarginArea = ({ elementID }: { elementID: string | null }) => {
  const [launcherElementsData] = useLauncherElementsStore<Record<string, LauncherElementData>>();
  const element = launcherElementsData[elementID || ''];

  const marginTop = extractNumber(element?.props?.class?.marginTop);
  const marginBottom = extractNumber(element?.props?.class?.marginBottom);
  const marginLeft = extractNumber(element?.props?.class?.marginLeft);
  const marginRight = extractNumber(element?.props?.class?.marginRight);

  return (
    elementID && (
      <Container
        style={{
          top: (marginTop || 0) * -1,
          left: (marginLeft || 0) * -1,
          right: (marginRight || 0) * -1,
          bottom: (marginBottom || 0) * -1,
          borderTop: marginTop ? '1px dotted #e47d1c' : undefined,
          borderLeft: marginLeft ? '1px dotted #e47d1c' : undefined,
          borderRight: marginRight ? '1px dotted #e47d1c' : undefined,
          borderBottom: marginBottom ? '1px dotted #e47d1c' : undefined,
        }}
      />
    )
  );
};

const Container = styled.div`
  pointer-events: none;
  box-sizing: border-box;
  position: absolute;

  display: flex;
  justify-content: center;
  align-items: center;
`;
